import * as actionTypes from "../actions/actionTypes";

const initState = {
  loadingPreview: false,
  previewPost: null,
  error: null,
  //submit:
  submiting: false,
  submited: null,
  submitError: null,
};

const initGetPreviewPost = (state, action) => {
  return {
    ...state,
    loadingPreview: action.loadingPreview,
    previewPost: action.previewPost,
  };
};

const successGetPreviewPost = (state, action) => {
  return {
    ...state,
    loadingPreview: action.loadingPreview,
    previewPost: action.previewPost,
  };
};

const failGetPreviewPost = (state, action) => {
  return {
    ...state,
    loadingPreview: action.loadingPreview,
    error: action.error,
  };
};

const initSendPostSubmit = (state, action) => {
  return {
    ...state,
    submiting: action.submiting,
  };
};

const successSendPostSubmit = (state, action) => {
  return {
    ...state,
    submiting: action.submiting,
    submited: action.submited,
  };
};

const failSendPostSubmit = (state, action) => {
  return {
    ...state,
    submiting: action.submiting,
    submitError: action.submitError,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_GET_PREVIEW_POST:
      return initGetPreviewPost(state, action);
    case actionTypes.SUCCESS_GET_PREVIEW_POST:
      return successGetPreviewPost(state, action);
    case actionTypes.FAIL_GET_PREVIEW_POST:
      return failGetPreviewPost(state, action);
    //SUBMIT:
    case actionTypes.INIT_SEND_POST_SUBMIT:
      return initSendPostSubmit(state, action);
    case actionTypes.SUCCESS_SEND_POST_SUBMIT:
      return successSendPostSubmit(state, action);
    case actionTypes.FAIL_SEND_POST_SUBMIT:
      return failSendPostSubmit(state, action);
    default:
      return state;
  }
};

export default Reducer;
